// Standalone login page client. Submits credentials, redirects on success.
// Honors a `?next=` query param so the user lands back where they tried to go.

interface LoginResponse { ok?: boolean; username?: string; error?: string }

function postLoginPath(): string {
  // The user wants to land back on the public site after logging in (not jump
  // straight into the CMS editor). The Logout button in the runtime sidebar
  // signals their session is active. From there, clicking the footer "Admin"
  // link again lands on /admin/ via the server-side redirect for logged-in
  // visits to /admin/login.
  return "/";
}

document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("login-form") as HTMLFormElement | null;
  const errBox = document.getElementById("login-error") as HTMLDivElement | null;
  if (!form) return;

  function showError(msg: string): void {
    if (!errBox) return;
    errBox.textContent = msg;
    errBox.hidden = false;
  }

  function clearError(): void {
    if (!errBox) return;
    errBox.hidden = true;
    errBox.textContent = "";
  }

  form.addEventListener("submit", async e => {
    e.preventDefault();
    clearError();
    const usernameEl = document.getElementById("username") as HTMLInputElement;
    const passwordEl = document.getElementById("password") as HTMLInputElement;
    const submitBtn = form.querySelector<HTMLButtonElement>('button[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    try {
      const r = await fetch("/admin/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: usernameEl.value, password: passwordEl.value }),
        credentials: "same-origin",
      });
      const j = await r.json() as LoginResponse;
      if (!r.ok || !j.ok) {
        showError(j.error ?? "Login failed");
        return;
      }
      window.location.assign(postLoginPath());
    } catch (err) {
      showError("Network error: " + String((err as Error).message ?? err));
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  });
});
